import { FormProps, FormTypes } from "../../../shared/interfaces/form";

export const userData = (id?: string, response?: any, roles?: any, isMaster?: boolean, company?: any): FormProps[] => {

    const data: FormProps[] = [
        {
            typeOfField: FormTypes.INPUT,
            type: 'text',
            placeholder: 'Nome*',
            value: id ? response?.name : null,
            name: 'name',
            rules: {
                required: 'O nome do usuário é obrigatório'
            },
            width: 740,
            height: 55,
        },
        {
            typeOfField: FormTypes.INPUT,
            type: 'text',
            mask: '(99) 99999-9999',
            placeholder: 'Telefone*',
            value: id ? response?.phone : null,
            name: 'phone',
            rules: {
                required: 'O telefone do usuário é obrigatório'
            },
            width: 300,
            height: 55,
        },
        {
            typeOfField: FormTypes.INPUT,
            type: 'text',
            placeholder: 'E-mail*',
            value: id ? response?.email : null,
            name: 'email',
            rules: {
                required: 'O e-mail do usuário é obrigatório'
            },
            width: 400,
            height: 55,
        },
        {
            typeOfField: FormTypes.SELECT,
            type: 'text',
            placeholder: 'Acesso*',
            value: id ? response?.roleId : null,
            name: 'roleId',
            rules: {
                required: 'O acesso do usuário é obrigatório'
            },
            options: {
                placeholder: 'Acesso',
                data: roles,
                value: id ? response?.roleId : null
            }
        }
    ];

    if(isMaster) {
        data.push({
            typeOfField: FormTypes.SELECT,
            type: 'text',
            placeholder: 'Empresa*',
            value: id ? response?.companyId : null,
            name: 'companyId',
            rules: {
                required: 'A empresa do usuário é obrigatória'
            },
            options: {
                placeholder: 'Empresa',
                data: company,
                value: id ? response?.companyId : null
            }
        });
    }

    if(!id) {
        data.push({
            typeOfField: FormTypes.INPUT,
            type: 'password',
            placeholder: 'Senha*',
            value: '',
            name: 'password',
            rules: {
                required: 'A senha do usuário é obrigatória'
            },
            width: 400,
            height: 55,
        });
    }

    return data;
};

export default userData;